

import { useContext, useEffect, useState } from "react";
import { StepperContext } from "./context/StepperContext";

export const useStepData = () => {
  const stepperState = useContext(StepperContext);
  const [data, setData] = useState<any>(null); 

  useEffect(() => {
   
    if (!stepperState?.data) {
      console.warn("StepperContext data is undefined or null");
      return;
    }

    console.log("data: ", stepperState.data);
    const stepData = stepperState.data.get(stepperState.currentStepIdx);

    console.log(
      "Step changed: ",
      stepperState.currentStepIdx,
      stepData
    );

    if (stepData) {
      setData(stepData);
    } else {
      setData(null); 
    }
  }, [stepperState?.currentStepIdx, stepperState.data.get(stepperState.currentStepIdx)]);

  return { data, setData };
};




